"use client"

import { useEffect } from "react"

export default function Layout({ children, modal }: { children: React.ReactNode; modal: React.ReactNode }) {
  useEffect(() => {
    // Remove dark class from document
    document.documentElement.classList.remove("dark")

    document.body.style.backgroundColor = "#FFF"
  }, [])

  return (
    <div className="relative">
      {children}
      {modal}
      <div id="modal-root" className="relative z-50" />
    </div>
  )
}
